import type { CategoryFragment } from "@/graphql";
import type { IMultiSelectItem, IOption } from "@/interfaces";

const toMultiSelectItem = (item: CategoryFragment): IMultiSelectItem => {
  return {
    id: item.id,
    title: item.title,
    imageURL: item.image?.source,
  };
};

const toOption = (item: CategoryFragment): IOption => {
  return {
    value: item.id,
    title: item.title,
  };
};

export default {
  toMultiSelectItem,
  toOption,
};
